export enum PackingStatus {
  YES = 'YES',
  NO = 'NO'
}